import { Linking, Platform, Share } from 'react-native';

/** "11999998888" → "5511999998888": o wa.me quer o número com o país. */
function toWhatsappNumber(phone: string | null | undefined): string | null {
  const digits = (phone ?? '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.startsWith('55') && digits.length >= 12) return digits;
  return `55${digits}`;
}

/**
 * Abre a conversa com o profissional já com o convite escrito. Sai do WhatsApp
 * do dono, e não da Evolution: sem custo e sem risco de ban.
 */
export async function sendInviteOnWhatsapp(phone: string | null, message: string) {
  const number = toWhatsappNumber(phone);
  const text = encodeURIComponent(message);
  const url = number ? `https://wa.me/${number}?text=${text}` : `https://wa.me/?text=${text}`;
  await Linking.openURL(url);
}

/**
 * Compartilhar nativo (qualquer app). Na web sem `navigator.share`, copia o
 * texto. Devolve `'copied'` para a tela avisar.
 */
export async function shareInvite(message: string): Promise<'shared' | 'copied'> {
  if (Platform.OS === 'web') {
    const nav = typeof navigator !== 'undefined' ? navigator : undefined;
    if (nav && typeof nav.share === 'function') {
      await nav.share({ text: message });
      return 'shared';
    }
    await nav?.clipboard?.writeText(message);
    return 'copied';
  }
  await Share.share({ message });
  return 'shared';
}
